const initialState = {
  name: '',
  number: '',
};

export default initialState;
